import * as React from "react";
import Pill from "./Pill";
import Icons from "../../constants/Icons";

const Ellipse = Icons.ellipse;

export const StatusPill = ({ status }: { status: string }) => {
    const colorMap = {
        Approved: "lime-green",
        Rejected: "pale-red",
    } as const;

    return (
        <Pill color={colorMap[status] ?? "amber"}>
            <Ellipse fill="currentColor" />
            {status}
        </Pill>
    );
};
